import MiniTablePro from "./MiniTablePro";
export default MiniTablePro;
